'use strict';

import React from 'react'

import Slider from 'react-slick'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import HolidaysMessage from '@/HolidaysMessage'

import Layout from '@Layout/ECFront'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

import { mergeDeep } from '@root/utility'

export default class FrontArtistPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			artist: { },
			products: [],
			products_references: [],
			loading: false
		};

		this.getRelatedProducts = this.getRelatedProducts.bind(this);
	}

	componentDidUpdate ()
	{
		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		let filter_query =
		{
			id: id
		};

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll',
		{
			model: 'artist',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				artist: response.data[0]
			});

			component.getRelatedProducts((response.data[0] || { }).id)
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	getRelatedProducts (id)
	{
		const component = this, props = this.props;

		qwest.post('/CMS/getAll',
		{
			model: 'product',
			filter_query: JSON.stringify(
			{
				artist: id || component.state.artist.id,
				disabled: { '!=': [true, 'true'] }
			})
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				products: response.data,
				products_references: response.references,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, artist = component.state.artist;

		const moment = window.moment;

		var loader;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />;
		}

		let images = (artist.images || []).map(function (data, index)
		{
			var output =
			(
				<div key={ index }>
					<Image className="c-model__carousel-image" src={ data.url } />
				</div>
			);

			return output;
		});

		const slider_settings =
		{
			dots: true,
			infinite: false,
			speed: 320,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			useCSS: true,
			breakpoint: 100,
			draggable: true
		};

		let slider;

		if (images.length)
		{
			slider =
			(
				<div className="o-grid__item-5">

					<div className="c-model__images">
						<Slider { ...slider_settings }>
							{ images }
						</Slider>
					</div>

				</div>
			);
		}

		let related_products = component.state.products.map(function (product)
		{
			let places = app.getReferedValue(
			{
				model: 'place',
				seek: 'name',
				references: component.state.products_references,
				id: product.places
			});

			if (places)
			{
				places =
				(
					<div className="c-model-preview__places">
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ places }
					</div>
				);
			}

			let short_description = (product.description || '').split('<br>').join('');

			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className=".c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 130, '') } } />
			);

			let img_url;

			if (product.images[0])
			{
				img_url = product.images[0].url;
			}
			else if (artist && artist.images[0])
			{
				img_url = artist.images[0].url;
			}
			else
			{
				img_url = '/images/Logo_Synergies.jpg';
			}

			let output =
			(
				<div className="c-model-preview-item product o-grid__item u-flex"
					key={ product.id }>

					<div className="c-model-preview c-model-preview--product">
						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ '/accueil/catalogue/' + product.id }>
								<Image className="c-model-preview__img"
									src={ img_url } />
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/accueil/catalogue/' + product.id }
								className="c-model-preview__title-link">
								{ product.name }
							</Link>
						</h2>

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_description }
							</div>

							{ places }

							<div className="c-model-preview__buttons">
								<Link href={ '/accueil/catalogue/' + product.id }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Voir le produit
								</Link>
							</div>

						</div>
					</div>

				</div>
			);

			return output;
		});

		let output =
		(
			<Layout page_title={ artist.name || 'Artiste' } history={ props.history }>

				<div className="page-content c-model c-model--artist">

					<HolidaysMessage />

					<div className="o-grid">

						{ slider }

						<div className={ slider ? 'o-grid__item-7' : 'o-grid__item-12 u-full-width' }>

							<div className="c-title u-no-margin-top">
								<h2 className="c-title__txt">
									{ artist.name }
								</h2>
							</div>

							<div className="c-model__body">

								<div className="c-model__description"
									dangerouslySetInnerHTML= { { __html: artist.description } }>
								</div>

							</div>

						</div>

						{ loader }

					</div>

					<div className="o-content">

						<div className="c-title u-no-margin-bottom">
							<h2 className="c-title__txt">
								Produits associés
							</h2>
						</div>

						<div className="c-model__body">

							<div className="o-grid-6">
								{ related_products }
							</div>

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
